export enum VariationsReportFilterEnum {
  ALL,
  LIMITED,
  UNLIMITED
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/dpp-analytics/variations-report-filter.enum.ts